import React from "react";
import styled from "styled-components";

//assets
import doodle from "assets/svg/doodle-arrow.svg";
import doodleUnderline from "assets/svg/doodle-underline.svg";
import doodleUnderline2 from "assets/svg/doodle-underline-2.svg";
import doodleUnderline2Purple from "assets/svg/doodle-underline-2-p.svg";
import doodleCircle from "assets/svg/circle.svg";
import trioCircle from "assets/svg/trio.svg";

const Bold = styled.span`
  font-weight: 700;
`;

const CustomSpan = styled.span`
position: relative;
z-index: 1;
&::before{
  content: "";
  position: absolute;
  z-index: -1;
}
&.underline, &.underline2, &.strikethrough, &.strikethrough2, &.trio {
  &::before{
    content: "";
    bottom: -10%;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 100%;
max-height:0.6em;
    background-image: url(${doodleUnderline});
background-position: center;
background-repeat: no-repeat;
background-size: contain;
  }
}

&.underline2 {
  &::before{
    background-image: url(${doodleUnderline2});
  }
}

&.purple.underline2  {
  &::before{
    background-image: url(${doodleUnderline2Purple});
  }
}

&.strikethrough, &.strikethrough2{
  &::before{
    bottom: initial;
    top: 50%;
    transform: translateY(-50%) translateX(-50%);
    background-image: url(${doodleUnderline});
    z-index: 10;
  }
  
}

&.trio{
  &::before{
    max-height: initial;
    height: 250%;
    width: 150%;

    background-image: url(${trioCircle});
  }
}
&.strikethrough2{
  &::before{
    background-image: url(${doodleUnderline2Purple});
  }
}
&.arrow{
  display: inline-block;
  padding-right: 2em;
  &::before{
    top: 0;
    left: 0rem;
    background-image: url(${doodle});
background-position: left;
background-repeat: no-repeat;
background-size: contain;
    width: 100%;
    height: 100%;
;
  }
}
&.circle{
  &::before{
    background-image: url(${doodleCircle});
    background-position: left;
background-repeat: no-repeat;
background-size: contain;
    width: 100%;
    height: 100%;
  }
}
`;

function TextWithLineBreaks(props) {
  // Check if props.text is a string
  if (typeof props.text !== "string") {
    return null;
  }

  // Function to parse bold tags and custom span tags within a text segment
  const parseTextWithTags = (text, lineIndex) => {
    const parts = [];
    const regex = /\{b\}(.*?)\{\/b\}|>([^<]+)<([^>]+)>/g;
    let lastIndex = 0;
    let match;
    let partIndex = 0;

    while ((match = regex.exec(text)) !== null) {
      // Add text before the bold tag
      if (match.index > lastIndex) {
        parts.push(
          <React.Fragment key={`line-${lineIndex}-part-${partIndex++}`}>
            {text.substring(lastIndex, match.index)}
          </React.Fragment>
        );
      }
      if (match[1] !== undefined) {
        // Add bold text
        parts.push(
          <Bold key={`line-${lineIndex}-bold-${partIndex++}`}>{match[1]}</Bold>
        );
      } else {
        // Add span with className from >text<className>
        parts.push(
          <CustomSpan
            className={`${match[3]} ${props.purple ? "purple" : ""}`}
            key={`line-${lineIndex}-class-${partIndex++}`}
          >
            {match[2]}
          </CustomSpan>
        );
      }
      lastIndex = regex.lastIndex;
    }

    // Add remaining text after the last bold tag
    if (lastIndex < text.length) {
      parts.push(
        <React.Fragment key={`line-${lineIndex}-part-${partIndex++}`}>
          {text.substring(lastIndex)}
        </React.Fragment>
      );
    }

    return parts.length > 0 ? parts : text;
  };

  // Process the string with line breaks and bold tags
  const textWithBreaks = props.text.split("\n").map((text, index, array) => (
    <React.Fragment key={index}>
      {parseTextWithTags(text, index)}
      {index < array.length - 1 && <br />}
    </React.Fragment>
  ));

  return <>{textWithBreaks}</>;
}

export default TextWithLineBreaks;
